import { IconButton, InputAdornment } from "@material-ui/core";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CheckIcon from '@mui/icons-material/Check';
import DescriptionIcon from '@mui/icons-material/Description';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import DownloadIcon from '@mui/icons-material/Download';
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import SendIcon from "@mui/icons-material/Send";
import { styled } from "@mui/material/styles";
import DispalyImage from "components/wrapperComponents/DispalyImage";
import FormikControl from "components/wrapperComponents/FormikControl";
import { msgTypes } from "constants/msgTypes";
import { RouteType } from "constants/RouteType";
import { Form, Formik } from "formik";
import { ChatAndMeetModel } from "model/screensModels/ChatAndMeetModel";
import { ContactPersonModel } from "model/screensModels/membership/ContactPersonModel";
import { MembershipModel } from "model/screensModels/membership/MembershipModel";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { RequestModel } from "model/utilModels/RequestModel";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LocalStorageService } from "services/auth/LocalStorageService";
import { ChatAndMeetService } from "services/menu/chatAndMeetService/ChatAndMeetService";
import ApiUrl from "services/shared/ApiUrl";
import { UploadFileService } from "services/shared/UploadFileService";
import { UtilService } from "services/shared/UtilService";
import "./ChatAndMeet.scss";


const ChatAndMeet = () => {
  const [contactPersonList, setContactPersonList] = useState([]);
  const [initialValue, setInitialValue] = useState(new ChatAndMeetModel());
  const [senderId, setSenderId] = useState("");
  const [receiverId, setReceiverId] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const [chatAndMeetData, setChatAndMeetData] = useState([]);
  const [attachment, setAttachment] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [companyData, setCompanyData] = useState(new MembershipModel());
  const location = useLocation();
  const [representativeDetails, setRepresentativeDetails] = useState(new ContactPersonModel())
  const [selectedCompanyId, setSelectedCompanyId] = useState(undefined);
  const [counter, setCounter] = useState(0);
  const [selectedPersonDetails, setSelectedPersonDetails] = useState(new ContactPersonModel());
  const navigate = useNavigate();

  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  });

  useEffect(() => {
    loadInit();
  }, []);

  const loadInit = async () => {
    await getContactPersonList();
    await getSenderDetails();
    await companyDetails();
    await getParamData();
  }

  useEffect(() => {
    newMessagesRef.current?.scrollIntoView({ block: "nearest" });
  }, [chatAndMeetData]);

  useEffect(() => {
    setAttachment(null);
    setInitialValue(new ChatAndMeetModel()); // reset initial values
  }, [selectedName]);

  const getParamData = async () => {
    try {
      const companyId = location.state?.selectedCompanyId;
      if (companyId != undefined) {

        const requestBody = new MembershipModel();
        requestBody.companyId = companyId;
        const res = await UtilService.getCompanyDetailsByCompanyId(requestBody);

        if (res.statusMsg === msgTypes.SUCCESS.msg) {
          // setCompanyData(res.data);
          const representative = res.data?.contactPerson.filter((data: ContactPersonModel) => {
            return data?.contactIsrepresentative === true;
          })

          setRepresentativeDetails(representative);

          const response = await ChatAndMeetService.getContactPersonList();
          if (response.statusMsg === msgTypes.SUCCESS.msg) {
            const contactperson = response?.data?.tbody.filter((data) => {
              return data?.contactEmail === representative[0]?.email;
            })
            getChatAndMeetData(contactperson[0]);
          }

        }
      }
    } catch (error) {
    }
  }

  const newMessagesRef = useRef(null);
  const attachmentRef = useRef(null);

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });


  const companyDetails = async () => {
    const userdeatil = JSON.parse(await LocalStorageService.getUserDetails());
    setCompanyData(userdeatil);
    const representative = userdeatil?.contactPerson.filter((data: ContactPersonModel) => {
      return data.contactIsrepresentative === true;
    })
    setRepresentativeDetails(representative[0])

  };

  // Set Sender Id
  const getSenderDetails = async () => {
    const res = JSON.parse(await LocalStorageService.getUserDetails());
    const compnayRepresentative = res.contactPerson.find((person) => person.contactIsrepresentative === true);
    setSenderId(compnayRepresentative?.contactPersonId)
  }

  const getContactPersonList = async () => {
    try {
      const res = await ChatAndMeetService.getContactPersonList();
      
      if (res?.statusMsg === msgTypes.SUCCESS.msg) {
        const contactList = (res.data?.tbody) ? res.data.tbody : [];  
        setContactPersonList(contactList);
      } else {
        setContactPersonList([]); // Handle failure case by setting an empty array
      }
    } catch (error) {
      console.error("Error fetching contact person list:", error);
      setContactPersonList([]); // Handle error case by setting an empty array
    }
  };
  

  // Search Contact person
  const searchedContactPersonList = contactPersonList.filter((contactPerson) =>
    contactPerson?.contactName?.toLowerCase().includes(searchTerm.toLowerCase())
  );


  // Prepare Data For API

  const prepareRequestBody = async (values: ChatAndMeetModel) => {
    const prepareData = new ChatAndMeetModel();
    prepareData.senderId = senderId;
    prepareData.receiverId = receiverId;
    prepareData.message = values.message ? values.message : "";

    // Prepare the attachment as a file
    if (attachment) {
      const formData = new FormData();
      formData.append("file", attachment);
      const attachmenturlData = await UploadFileService.getImagePath(formData);

      if (attachmenturlData && attachmenturlData.data?.fileName) {
        prepareData.attachment = attachmenturlData.data?.fileName;
      }
    } else {
      prepareData.attachment = "";
    }
    return prepareData;
  };

  const addChatAndMeet = async (values: ChatAndMeetModel) => {
    const requestData = await prepareRequestBody(values);
    const res = await ChatAndMeetService.addChatAndMeet(requestData);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      const data = [...chatAndMeetData, res.data];
      setChatAndMeetData(data);
      //markAsReadMessage(requestData)
    }
  };

  // On Enter Press Message Sent
  const messageSentOnEnterPress = async (e, values: ChatAndMeetModel, { resetForm }) => {
    if (e.charCode === 13) {
      e.preventDefault();
      if ((values.message).trim().length > 0 || attachment !== null) {
        await addChatAndMeet(values);
        resetForm();
        setAttachment(null);
      }
    }
  }

  // Mark message as a read message
  const markAsReadMessage = async (requestData: ChatAndMeetModel | RequestModel) => {
    const res = await ChatAndMeetService.markAsReadMessage(requestData);
    return res;
  }

  // Prepare Request Body To Get Chat And Meet Data
  const prepareRequest = async (selectedId) => {
    const requestBody = new RequestModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = 1000//pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    requestBody.senderId = senderId;
    requestBody.receiverId = selectedId;
    return requestBody;
  };

  // Get Chat And Meet Data
  const getChatAndMeetData = async (contactPerson) => {
    setReceiverId(contactPerson.personIdentifier);
    setSelectedName(contactPerson.contactName);
    setSelectedPersonDetails(contactPerson)
    //setChatAndMeetData([]);

    const requestBody = await prepareRequest(contactPerson.personIdentifier);
    const res = await ChatAndMeetService.getChatAndMeetData(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        if (res.data != undefined) {
          setChatAndMeetData(res.data.tbody);
          await markAsReadMessage(requestBody);
          getContactPersonList()
        }
      }
    }
  };

  //Redirect to Quotes page
  const onClickQuotes = () => {
    navigate(RouteType.HOME + RouteType.MEMBER_SEARCH);
  }

  //Redirect to Invoice page
  const onClickInvoice = () => {
    navigate(RouteType.HOME + RouteType.INVOICE_MANAGEMENT);
  }

  // Save chat data by clicking on input icon
  const onSubmit = async (values: ChatAndMeetModel, { resetForm }) => {
    if ((values.message).trim().length > 0 || (attachment !== null && attachment !== '')) {
      await addChatAndMeet(values);
      resetForm();
      setAttachment(null);
    }
  };

  //On focus get, mark message as a read and user is active with selected receiver
  const onFocusGet = async () => {
    const chatModel = new ChatAndMeetModel();
    chatModel.senderId = senderId;
    chatModel.receiverId = receiverId;
    await ChatAndMeetService.markAsActiveUser(chatModel)
  }

  //On focus lost mark user is inactive
  const handleBlur = async () => {
    const chatModel = new ChatAndMeetModel();
    chatModel.senderId = senderId;
    chatModel.receiverId = receiverId;
    await ChatAndMeetService.markAsDeactiveUser(chatModel)
  };

  const handleSelectAttachment = (e) => {
    setAttachment(e.target.files[0]);
    setCounter(counter + 1);
  }

  return (
    <>
      <div
        className="content-one d-flex flex-column flex-column-fluid"
        id="kt_content">
        {/* <!--begin::Entry--> */}
        <div className="d-flex flex-column-fluid">
          {/* <!--begin::Container--> */}
          <div className="container">
            {/* Begin:: Representative Details */}
            <div className="row page-content">

              <div className="col-lg-12">
                <div className="card card-body border-0 blur bg-transparent-list shadow-blur overflow-hidden background-new">
                  <div className="d-flex justify-content-between flex-wrap align-items-center gx-4">
                    <div>
                      <div className="d-flex">
                        <div className="avatar avatar-xl border-radius-lg overflow-hidden shadow-sm position-relative">
                          {representativeDetails != undefined &&
                            // <img src={ApiUrl.fileBaseUrl + representativeDetails?.contactPersonImage} alt="profile_image" className="w-100 h-100" />
                            <DispalyImage
                              imageUrl={representativeDetails?.contactPersonImage}
                              imageSize={msgTypes.IMAGE_SIZE.MEDIUM} />
                          }
                        </div>
                        <div className="h-100">
                          <p className="mb-0 font-weight-bold text-sm">{representativeDetails?.name}</p>
                          <p className="mb-0 font-weight-bold text-sm">{representativeDetails?.position} </p>
                          <p className="mb-0 font-weight-bold text-m">{companyData?.companyName} </p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="nav-wrapper position-relative end-0">
                        <ul className="nav nav-pills nav-fill p-1 bg-transparent justify-content-end" role="tablist">
                          <li className="nav-item mb-2 active">
                            <a className="nav-link shadow-blur">
                              < NoteAltIcon />
                              <span onClick={onClickQuotes} className="ms-1">Quotes</span>
                            </a>
                          </li>
                          <li className="nav-item mb-2">
                            <a className="nav-link shadow-blur">
                              <DescriptionIcon />
                              <span onClick={onClickInvoice} className="ms-1">Invoice</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            {/* End:: Representative Details */}

            <div className="row card-margin-top">
              {/* Begin:: Memberlist Side Pan */}
              <div className="col-lg-4 card--">
                {/* <!--begin::Body--> */}
                <div className="sub-content-sec  chat-meet-section">
                  <div>
                    <div className="input-group input-group-solid p-3 pb-1">
                      <input type="text"
                        className="form-control"
                        placeholder="Search Contact"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>

                    <div className="max-height overflow-auto overflow-x-hidden mt-2 scroll p-2 scroll-pull ps ps--active-y being-user-height chat-meet-contactperson">
                      {/* <!--begin:User--> */}
                      {searchedContactPersonList?.map((contactPerson, index) => (
                        <a href="javascript:void(0)" className="text-decoration-none" key={index}
                          onClick={() => {
                            getChatAndMeetData(contactPerson); setChatAndMeetData([])
                          }}>
                          <div key={contactPerson.personIdentifier}>
                            <div className={(contactPerson.personIdentifier === receiverId) ? "d-flex align-items-center justify-content-between p-2 bg-chat-meet" : "d-flex align-items-center justify-content-between p-2"}>
                              <div className="d-flex">
                                {contactPerson?.contactImageUrl ?
                                  <div className="symbol symbol-circle chat-meet symbol-50 mr-3">
                                    <img
                                      alt="Pic"
                                      className="avatar shadow mr-3"
                                      src={
                                        ApiUrl.fileBaseUrl +
                                        contactPerson?.contactImageUrl
                                      }
                                    />
                                  </div>
                                  :
                                  <div className="symbol symbol-circle default-img symbol-50 mr-3">
                                    <img
                                      alt="Pic"
                                      className="avatar shadow"
                                      src="/images/user.png"
                                    />
                                  </div>
                                }

                                <div className="d-flex flex-column meet-img">
                                  <h6
                                    className=" font-weight-bold font-size-lg p-0 m-0"
                                    onClick={() => {
                                      getChatAndMeetData(contactPerson);

                                    }}
                                  >
                                    {contactPerson?.contactName}
                                  </h6>
                                  <h6 className="cont-p-1  font-weight-bold font-size-sm p-0 m-0">{contactPerson.companyName}</h6>
                                  {contactPerson.lastMessageSentAt && (
                                    <>
                                      <div className="d-flex">
                                        {/* Display the time */}
                                        <p className="cont-p text-muted text-xs mb-1">
                                          {new Date(
                                            contactPerson.lastMessageSentAt
                                          ).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })}
                                        </p>
                                        {/* Display the date */}
                                        <p className="cont-p text-muted text-xs p-0 mb-1">
                                          {new Date(
                                            contactPerson.lastMessageSentAt
                                          ).toLocaleDateString()}
                                        </p>
                                      </div>
                                    </>
                                  )}
                         
                                </div>
                              </div>
                              {/* unread message */}
                              <div>
                                {contactPerson.unreadMessageNo > 0 && (
                                  <div className="unread-message">{contactPerson.unreadMessageNo}</div>
                                )}
                              </div>
                            </div>
                            {/* <!--end:User--> */}

                            <div className="ps__rail-x l-0 end-user-alignment">
                              <div className="ps__thumb-x end-user-alignment"></div>
                            </div>
                            <div className="ps__rail-y end-user-height">
                              <div className="ps__thumb-y end-user-heightx"></div>
                            </div>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>

                </div>
                {/* <!--end::Body--> */}
              </div>
              {/* End:: Memberlist Side Pan */}

              <div className="col-lg-8 card--">
                {/* <!--begin::Content--> */}
                <div className="sub-content-sec h-100 p-0 chat-meet-section dash-one">
                  {/* <!--begin::Card--> */}
                  {selectedName ? (
                    <Formik
                      initialValues={initialValue}
                      onSubmit={onSubmit}
                      resetForm
                    >
                      {({ isValid, isSubmitting, values, resetForm, submitForm,
                      }) => (
                        <Form className="h-100">
                          <div className="card card-custom border-0 chat-meet-card">
                            {/* <!--begin::Chat section Header--> */}
                            <div className="card-header shadow-md align-items-center ">

                              <div className="flex-grow-1 d-flex align-items-center">
                                <div className="d-flex card-header-image">
                                  {selectedPersonDetails?.contactImageUrl ?
                                    <div className="symbol symbol-circle symbol-50 mr-3">
                                      <img
                                        alt="Pic"
                                        className="avatar shadow"
                                        src={ApiUrl.fileBaseUrl + selectedPersonDetails.contactImageUrl}
                                      />
                                    </div>
                                    :
                                    <div className="symbol symbol-circle symbol-50 mr-3">
                                      <img
                                        alt="Pic"
                                        className="avatar shadow"
                                        src="/images/user.png"
                                      />

                                    </div>
                                  }
                                  <div className="person-name">
                                    <div>
                                      <h6 className="mb-0">{selectedName}</h6>
                                      <span className="label label-md label-dot label-success ml-2"></span>
                                    </div>
                                    <div>
                                      <h6 className="cont-p-1 per font-size-sm m-0">{selectedPersonDetails.companyName}</h6>
                                    </div>
                                  </div>

                                </div>

                                <div>
                                  <span className="font-weight-bold text-muted font-size-md">
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* <!--end::Chat section Header--> */}



                            {/* <!--begin::Chat Body--> */}
                            <div className="card-body chat-meet-card--body">
                              {/* <!--begin::Scroll--> */}
                              <div
                                className="overflow-auto body-height mb-2"
                                data-mobile-height="350"
                              >
                                {/* <!--begin::Messages--> */}
                                <div className="messages chat-meet-messages">
                                  {chatAndMeetData?.length > 0 &&
                                    chatAndMeetData?.map((messageData) => {
                                      return (
                                        <>
                                          <div className="msg-sender" key={messageData.chatId}>
                                            {messageData.receiverId ===
                                              senderId && messageData.senderId !== messageData.receiverId ? (
                                              <IncomingMessage
                                                messageData={messageData} selectedPersonDetails={selectedPersonDetails} senderId={senderId}
                                              />
                                            ) : (
                                              <OutgoingMessage
                                                messageData={messageData}
                                              />
                                            )}
                                          </div>
                                        </>
                                      );
                                    })}
                                  <div ref={newMessagesRef}></div>
                                </div>
                                {/* <!--end::Messages--> */}
                              </div>
                              {/* <!--end::Scroll--> */}
                            </div>
                            {/* <!--end::Chat Body--> */}



                            {/* <!--begin::Chat Footer--> */}
                            <div className="card-footer px-3 pt-2 p-0 border-0 align-items-center position-relative d-flex justify-content-between">

                              {/* <a
                                href="#"
                              > */}
                                <VisuallyHiddenInput
                                  ref={attachmentRef}
                                  onChange={(e) => { handleSelectAttachment(e) }}
                                  accept= {msgTypes.ALL_EXTENSIONS}
                                  type="file"
                                  height={100}
                                />
                              {/* </a> */}
                              {attachment ? (
                                <div className="d-flex align-items-center w-100 justify-content-between border mb-3 chatmeet--">
                                  {/* Image preview */}
                                  <div className="hello1">
                                    {attachment.type.startsWith("image/") ? (
                                      <>
                                        <img
                                          className="chat-and-meet-attachment-image"
                                          src={URL.createObjectURL(attachment)}
                                          alt="Preview"
                                        />
                                        <HighlightOffIcon
                                          color="error"
                                          className="delete-image-btn chat-and-meet-attachment-delete"
                                          onClick={() => setAttachment(null)}
                                        />
                                      </>
                                    ) : (
                                      <div className="d-flex align-items-center chat-and-meet-attachment-file ml-3">
                                        {/* {attachment.type === "application/pdf" ? ( */}
                                        <a
                                          href={URL.createObjectURL(attachment)}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="chat-and-meet-attachment-pdf-file"
                                        >
                                          {attachment?.name}
                                        </a>
                                        <HighlightOffIcon
                                          color="error"
                                          className="delete-image-btn chat-and-meet-attachment-delete"
                                          onClick={() => setAttachment(null)}
                                        />
                          
                                      </div>
                                    )}


                                  </div>

                                  <div className="hello2">
                                    <IconButton className="send-icon-btn" edge="end">
                                      <SendIcon onClick={!attachment && !values.message ? null : submitForm}
                                        className={`send-icon ${!attachment && !values.message ? "disabled" : "enabled"}`}
                                      />
                                    </IconButton>
                                  </div>
                                </div>

                              ) : (<></>)}


                              {!attachment && (
                                <>
                                  <div className="chat-meet-message" >
                                    <FormikControl
                                      control="textfield"
                                      name="message"
                                      placeholder="Type here"
                                      type="text"
                                      variant="outlined"
                                      multiline
                                      rows={2}
                                      fullWidth
                                      onKeyPress={(e) => messageSentOnEnterPress(e, values, { resetForm })}
                                      onFocus={onFocusGet}
                                      onBlur={(e) => { handleBlur() }}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                          <IconButton
                                            edge="end"
                                            onClick={(e) => {
                                              e.preventDefault(); // Prevents accidental form submission
                                              attachmentRef.current.click();
                                            }}
                                          >
                                            <AttachmentIcon className="attachment-btn" color="action" name="attachment" />
                                          </IconButton>
                                          <IconButton className="send-icon-btn" edge="end" onClick={!attachment && !values.message ? null : submitForm}>
                                            <SendIcon className={`send-icon send-padding ${!attachment && !values.message ? "disabled" : "enabled"}`} />
                                          </IconButton>
                                        </InputAdornment>
                                        
                                        ),
                                      }}
                                    />
                                  </div>


                                </>
                              )}
                            </div>
                            <div className="notes">
                              <small>Note: &nbsp; Please be advised that all attachments and files will be permanently deleted after a period of 30 days.</small>
                            </div>
                            {/* <!--end::Chat Footer--> */}
                          </div>
                        </Form>
                      )}
                    </Formik>
                  ) : (
                    ""
                  )}
                  {/* <!--end::Card--> */}
                </div>
                {/* <!--end::Content--> */}
              </div>
            </div>


          </div>
          {/* <!--end::Container--> */}
        </div>
        {/* <!--end::Entry--> */}
      </div>
    </>
  );
};

const IncomingMessage = ({ messageData, selectedPersonDetails, senderId }) => {
  const incomingMessageTime = new Date(
    messageData.createdAt
  ).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <>
      {/* <!-- Begin :: Incoming Messages --> */}
      <div className="d-flex flex-column message-incoming mt-3 align-items-start">
        <div className="card border-0">
          <div className="card-body chat-body py-2 px-3">
            <p className="mb-1">{messageData.message}</p>
            {messageData.attachment && (
              <>
                {((messageData.attachment.endsWith(".jpg") ||
                  messageData.attachment.endsWith(".png") ||
                  messageData.attachment.endsWith(".jpeg")) && messageData.attachment !== null) && (
                    <img
                      src={`${ApiUrl.fileBaseUrl}${messageData.attachment}`}
                      alt="Attachment"
                      className="img-perfection"
                    />
                  )}

                {messageData.attachment.endsWith(".pdf") && (
                  <a
                    href={`${ApiUrl.fileBaseUrl}${messageData.attachment}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {messageData.attachment &&
                      messageData.attachment.split("/").pop()}
                  </a>
                )}

                <a
                  href={`${ApiUrl.fileBaseUrl}${messageData.attachment}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <DownloadIcon className="download-icon-btn" />
                </a>

              </>
            )}

            <div className="d-flex align-items-center text-sm opacity-6">
              <i className="ni ni-check-bold text-sm me-1"></i> <small>{incomingMessageTime}</small>
            </div>
          </div>
        </div>
      </div>

 
    </>
  );
};

const OutgoingMessage = ({ messageData }) => {
  const outgoingMessageTime = new Date(
    messageData.createdAt
  ).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
  return (
    <>
      {/* <!-- Begin :: Outgoing Messages --> */}
      <div className="d-flex flex-column mt-3 meessage-outgoing align-items-end">
        <div className="card border-0 bg-gray-200">
          <div className="card-body chat-body py-2 px-3">
            <p className="mb-0">{messageData.message}</p>
            <div>

              {messageData.attachment && (
                <>
                  {(messageData.attachment.endsWith(".jpg") ||
                    messageData.attachment.endsWith(".png") ||
                    messageData.attachment.endsWith(".jpeg")) ? (
                    <img
                      src={`${ApiUrl.fileBaseUrl}${messageData.attachment}`}
                      alt="Attachment"
                      className="img-perfection"
                    />
                  ) : (

                    <a
                      href={`${ApiUrl.fileBaseUrl}${messageData.attachment}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {messageData.attachment &&
                        messageData.attachment.split("/").pop()}
                    </a>
                  )}
                  <a
                    href={`${ApiUrl.fileBaseUrl}${messageData.attachment}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="down-icon--"
                  >
                    <DownloadIcon />
                  </a>
                </>
              )}
              <div className="d-flex justify-content-end  text-sm opacity-6">
                <div className="d-flex align-items-end">{messageData.unreadMessageNo===false ? <CheckIcon className="check-icon" /> : <DoneAllIcon className="doneall-icon" />}</div>
                <div className="d-flex align-items-end justify-content-end">
                  <small>{outgoingMessageTime}</small>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
      {/* <!-- End :: Outgoing Messages --> */}
    </>
  );
};

export default ChatAndMeet;
